export default __webpack_public_path__ + "static/media/avatar.175740da.png";